let newsletter_fix = {
    init(formId, alreadyExistsErrorMessage) {
        this.formId = formId;
        this.form = document.getElementById(formId);
        this.urlParams = new URLSearchParams(window.location.search);
        this.alreadyExistsErrorMessage = alreadyExistsErrorMessage;

        this.validate();
    },

    validate() {
        const contact_tags = this.urlParams.get('contact[tags]');
        const form_type = this.urlParams.get('form_type');
        const error = this.form.querySelector('.site-footer__newsletter-error');

        if (contact_tags == 'newsletter' && form_type == 'customer' && error == null) {
            this.form.querySelector('.input-group').classList.add('input-group--error');
            this.form.querySelector('.input-group input').classList.add('input--error');
            this.form.setAttribute('aria-invalid', 'true');
            this.form.setAttribute('aria-describedby', `${this.formId}-email-error`);
            this.form.setAttribute('data-form-status', '');

            this.form.innerHTML += `
                <span id="{{ formId }}-email-error" class="input-error-message">
                    <span class="visually-hidden">${this.alreadyExistsErrorMessage}</span>
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 14 14"><g fill="none" fill-rule="evenodd"><path d="M7 0a7 7 0 0 1 7 7 7 7 0 1 1-7-7z"></path><path class="icon-error__symbol" d="M6.328 8.396l-.252-5.4h1.836l-.24 5.4H6.328zM6.04 10.16c0-.528.432-.972.96-.972s.972.444.972.972c0 .516-.444.96-.972.96a.97.97 0 0 1-.96-.96z"></path></g></svg>
                    <span class="site-footer__newsletter-error">${this.alreadyExistsErrorMessage}</span>
                </span>
            `;
        }
    }
}